const scrollToTop = document.querySelector('.scroll-to-top');

document.addEventListener('DOMContentLoaded', () => {
	toggleScrollTopVisibility();
});

window.addEventListener('scroll', () => {
	toggleScrollTopVisibility();
});

scrollToTop.addEventListener('click', () => {
	window.scroll({
		top: 0,
		left: 0,
		behavior: 'smooth',
	});
});

function toggleScrollTopVisibility(scrollHeight = 100) {
	if (window.scrollY > scrollHeight) {
		scrollToTop.classList.add('visible');
	} else {
		scrollToTop.classList.remove('visible');
	}
}
